let myFirebaseSetup = function () {
  const config = {
    authDomain: "reuse-2d693.firebaseapp.com",
    databaseURL: "https://reuse-2d693.firebaseio.com",
    projectId: "reuse-2d693",
    storageBucket: "reuse-2d693.appspot.com",
    messagingSenderId: "722983492406",
    appId: "1:722983492406:web:b1b3d76c6c25e36afff197",
    measurementId: "G-07GRWNHG77"
  }

  return {
    config
  }
}();

export default myFirebaseSetup;